import { createRoute, useEntityUrl } from 'framework/routing';
import { POSITION_SLOTS_PATH } from './constants';

export const usePositionSlotsRoute = () => {
  return createRoute({ listRoute: POSITION_SLOTS_PATH });
};

export const usePositionSlotsUrl = () => useEntityUrl({ baseLink: POSITION_SLOTS_PATH });
